import { View, Text } from "react-native";

interface TagProps {
  label: string;
}

export function Tag({ label }: TagProps) {
  return (
    <View className="bg-accent rounded-full px-4 py-2">
      <Text className="text-primary text-sm font-semibold capitalize">
        {label}
      </Text>
    </View>
  );
}
